import { useEffect, useState } from 'react';
import {
  getSummary,
  getTopPages,
  getTimeseries,
  getRecentEvents,
} from '@/services/analyticsApi';

function iso(d) {
  return d.toISOString();
}

export default function useWebsiteAnalytics(initialDays = 7) {
  const [from, setFrom] = useState(() => {
    const d = new Date();
    d.setDate(d.getDate() - initialDays);
    return d;
  });
  const [to, setTo] = useState(() => new Date());

  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState(null);

  const [summary, setSummary] = useState(null);
  const [topPages, setTopPages] = useState([]);
  const [timeseries, setTimeseries] = useState([]);
  const [recent, setRecent] = useState([]);

  async function refresh() {
    setLoading(true);
    setErr(null);
    try {
      const [sum, top, ts, rec] = await Promise.all([
        getSummary({ from: iso(from), to: iso(to) }),
        getTopPages({ from: iso(from), to: iso(to), limit: 10 }),
        getTimeseries({ from: iso(from), to: iso(to) }),
        getRecentEvents({ limit: 50 }),
      ]);
      setSummary(sum?.totals || null);
      setTopPages(top?.rows || []);
      setTimeseries(ts?.points || []);
      setRecent(rec?.rows || []);
    } catch (e) {
      setErr(e);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    refresh(); /* re-run when dates change */
  }, [from, to]);

  return {
    from,
    to,
    setFrom,
    setTo,
    loading,
    err,
    summary,
    topPages,
    timeseries,
    recent,
    refresh,
  };
}
